import { LucideIcon } from "lucide-react";
import { ArchiveIcon, UsersIcon } from "lucide-react";

export type NavigationItem = {
  icon: LucideIcon;
  label: string;
  href: string;
  requiredRoles?: string[];
  requiredPermissions?: string[];
};

export type NavigationGroup = {
  label: string;
  items: NavigationItem[];
  requiredRoles?: string[];
  requiredPermissions?: string[];
  collapsible?: boolean;
};

export const navigationConfig: NavigationGroup[] = [
  {
    label: "Pages",
    items: [
      {
        icon: ArchiveIcon,
        label: "Cases",
        href: "/case/all",
      },
    ],
  },
  {
    label: "Admin Settings",
    items: [
      {
        icon: UsersIcon,
        label: "Clinicians",
        href: "/admin/clinicians",
        requiredRoles: ["Admin"],
      },
    ],
  },
];
